import { post } from "mdui/api/HttpReq";

const feeCalculationIaft = async ({ props, formData, updateState, config, setCfg, ...data }) => {
    let val = await post('fee-cal', 'list', formData)
    console.log('feeCalculation val2', val)

    let newFormData = {
        ...formData, 
        ...val,
        cnvtdAmt:val?.lclEqAmt
    }
    console.log("formdata",newFormData)
    updateState({ newFormData })
}


const hasValue = (v) => v !== null && v !== undefined && v !== "";

const ccyOnChange = async ({ props, formData, updateState, config, setCfg, ...data }) => {

    const newFormData = {
        ...formData,
        trxnCcy: formData.debitCcy
    };

    const { debitCcy, creditCcy } = newFormData;

    if (hasValue(debitCcy) && hasValue(creditCcy)) {
        await feeCalculationIaft({
            props,
            formData: newFormData,
            updateState,
            config,
            setCfg,
            ...data
        });
    } 
    else {
        updateState({ newFormData });
    }
};

const initEditCalculations = async ({ props, formData, updateState, config, setCfg, clearForm, loadCfg, modNm, mtype, ...data }) => {
    // Step 1: get exchange rate first (since ccy is readonly, this never fires on its own)
    let exchgVal = await post('exchg-rate-cal', 'list', formData)
    let formDataAfterExchg = { ...formData }

    if (exchgVal) {
        formDataAfterExchg = {
            ...formData,
            ...exchgVal
        }
    }
    let { procMode, ...restFormDataAfterExchg } = formDataAfterExchg

    // push the exchange-rate result into state so the UI reflects it
    updateState({ newFormData: restFormDataAfterExchg })

    // Step 2: run fee calc using the UPDATED formData (post-exchange-rate),
    // not the original stale formData
    let feeVal = await post('fee-cal', 'list', { ...restFormDataAfterExchg, module: props.field.moduleId })
    let { errors, ...restFeeVal } = feeVal

    let newFormData = {
        ...restFormDataAfterExchg,
        ...restFeeVal
    }

    let nattr = { ...data.attr }
    let fields = ['creditAmt']

    for (let field of fields) {
        if (data.attr?.[field]) {
            let originalAttr = { ...data.attr[field] }
            delete originalAttr.err
            nattr[field] = originalAttr
        }
    }

    if (errors && typeof errors === 'object') {
        for (let [fieldName, errorCode] of Object.entries(errors)) {
            let attributes = nattr[fieldName] || {}
            delete attributes['err']
            nattr[fieldName] = { ...attributes, err: errorCode }
        }
    }

    updateState({ newFormData, newAttr: nattr })
}


export { feeCalculationIaft, ccyOnChange,initEditCalculations}